package or.garden.manager.features.beds.components

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.dom.*

@Composable
fun BedsCard(
    name: String,
    size: String,
    status: String,
    onSettingsClick: () -> Unit,
    onPlannerClick: () -> Unit,
    onDeleteClick: () -> Unit
) {
    Div({
        classes(
            "bg-white", "rounded-3xl", "p-8", "shadow-sm", "border", "border-gray-100", "relative", "hover:shadow-md", "transition-shadow"
        )
    }) {
        // Actions Container (Top Right)
        Div({
            classes("absolute", "top-6", "right-6", "flex", "items-center", "gap-3")
        }) {
            // Delete Icon
            Div({
                classes("text-gray-300", "cursor-pointer", "hover:text-red-500", "transition-colors")
                onClick { onDeleteClick() }
            }) {
                I({ classes("fas", "fa-trash-alt", "text-lg") })
            }

            // Settings Icon
            Div({
                classes("text-gray-300", "cursor-pointer", "hover:text-gray-500", "transition-colors")
                onClick { onSettingsClick() }
            }) {
                I({ classes("fas", "fa-cog", "text-xl") })
            }
        }

        // Icon Header
        Div({
            classes(
                "w-14", "h-14", "bg-[#ECFDF5]", "rounded-2xl", "flex", "items-center", "justify-center", "mb-6"
            )
        }) {
            I({ classes("fas", "fa-database", "text-[#10B981]", "text-2xl") })
        }

        // Content
        H2({ classes("text-2xl", "font-bold", "text-[#1F2937]") }) { Text(name) }

        Div({ classes("flex", "items-center", "gap-2", "mt-3", "text-[#6B7280]") }) {
            val statusColor = if (status == "Active") "#10B981" else "#F59E0B"
            Div({
                classes("w-2", "h-2", "rounded-full")
                style { property("background-color", statusColor) }
            })
            Span { Text("$size • ${if (status == "Active") "Aktivno" else "U pripremi"}") }
        }

        // Footer Actions
        Div({
            classes(
                "flex", "justify-between", "items-center", "mt-10", "pt-6", "border-t", "border-gray-50"
            )
        }) {
            Span({
                classes(
                    "font-bold", "text-[#10B981]", "text-sm", "tracking-wider"
                )
            }) { Text("AKTIVNO") }

            Div({
                classes(
                    "flex", "items-center", "gap-2", "text-[#10B981]", "cursor-pointer", "hover:underline"
                )
                onClick { onPlannerClick() }
            }) {
                Span({ classes("font-bold") }) { Text("Planer") }
                I({ classes("fas", "fa-chevron-right", "text-xs") })
            }
        }
    }
}
